import React, {useState, useContext, createContext, ReactNode} from 'react'
import useTpaRevenueTrackingCookies from './tpa/tpaRevenueTracking/useTpaRevenueTrackingCookies'
import useTpaBrandingCookies from './tpa/tpaBranding/useTpaBrandingCookies'
import useAsiFlexCookies from './tpa/asiFlexData/useAsiFlexCookies'
import {CookieValuesType} from './tpa/types'
import {getTpaBrandingValuesFromCookies} from './tpa/tpaBranding/utils'

type CookieTrackerContextType = {
    cookieValues: CookieValuesType
}

const CookieTrackerContext = createContext<CookieTrackerContextType>({
    cookieValues: {
        tpaBranding: null,
        asiFlexData: null
    }
})

type CookieTrackerProviderProps = {
    children: ReactNode
}

export const useCookieTracker = () => useContext(CookieTrackerContext)

const CookieTrackerProvider = ({children}: CookieTrackerProviderProps) => {
    const [cookieValues, setCookieValues] = useState<CookieValuesType>(() => ({
        tpaBranding: getTpaBrandingValuesFromCookies() ?? null,
        asiFlexData: null
    }))
    useTpaRevenueTrackingCookies()
    useTpaBrandingCookies(setCookieValues)
    useAsiFlexCookies(setCookieValues)

    return (
        <CookieTrackerContext.Provider value={{cookieValues}}>
            {children}
        </CookieTrackerContext.Provider>
    )
}
export default CookieTrackerProvider
